import React, { CSSProperties, ReactNode } from 'react';
import { Button, Dropdown, DropdownButton, Table } from 'react-bootstrap';
import XLSX from 'xlsx';
import { downloadBlob, printDataAsTable } from '../utils';
import { HeaderDisplayKeysWithType } from './EditableTable';

type Props<T extends Record<string, unknown>> = {
  tableId?: string;
  title: string;
  values: T[];
  headers: (HeaderDisplayKeysWithType<T> & { display: string })[];
  context?: Record<string, unknown>;
  btnname?: string;
};

const headerStyle: CSSProperties = {
  position: 'sticky',
  top: 0,
  backgroundColor: '#efefef',
  color: '#3f4d67',
  zIndex: 99,
  border: '0.5px solid #e5e5e5',
  padding: '0.2rem 0.3rem',
};
const oddRowStyle: CSSProperties = {
  backgroundColor: '#a6f0ff',
};
const cellStyle: CSSProperties = {
  border: '0.5px solid #e5e5e5',
  padding: '0.2rem 0.3rem',
};

export const SheetTemplate = <T extends Record<string, unknown>>({
  tableId = 'sheet',
  title,
  values,
  headers,
  context = {},
  btnname = 'Excel 下載',
}: Props<T>) => {
  const footer =
    '承辦人:　　　　　　　　　　　　　組長:　　　　　　　　　　　　　主任:　　　　　　　　　　　　　　校長:　　　　　　　　　　　　';

  const headerElements = headers.map((h, i) => {
    return (
      <th style={headerStyle} key={`header-${i}`}>
        {h.display}
      </th>
    );
  });

  let bodyElements = values.map((v, i) => {
    const elements = headers.map((h, j) => {
      const value = h.onRender
        ? h.onRender(v[h.property], i, false, {
          context,
          allValues: v,
        })
        : v[h.property];

      return (
        <td style={cellStyle} key={`body-v${i}-h${j}`}>
          {value}
        </td>
      );
    });

    return (
      <tr
        style={i % 2 === 0 ? oddRowStyle : {}}
        key={`body-v${i}`}
      >
        {elements}
      </tr>
    );
  });

  if (values.length === 0) {
    bodyElements = [
      <tr key="empty-body">
        <td colSpan={999}>無資料</td>
      </tr>,
    ];
  }

  return {
    downloadButton: (
      <DropdownButton
        id={`${tableId}-export`}
        title="匯出"
        variant="success"
        disabled={!values.length}
      >
        {/* Excel 下載 */}
        <Dropdown.Item
          onClick={() => {
            const tableElement =
              document.querySelector(`#${tableId}`);

            if (tableElement !== null) {
              const content =
                '<meta charset=utf-8>' +
                tableElement.innerHTML +
                '<br/> <br/>' +
                footer;

              const blob = new Blob(
                [content],
                {
                  type: 'application/excel',
                }
              );

              downloadBlob(
                blob,
                `${title}.xls`
              );
            }
          }}
        >
          Excel 下載
        </Dropdown.Item>

        {/* 列印 */}
        <Dropdown.Item
          onClick={() => {
            printDataAsTable({
              title,
              values,
              headers,
              context,
              footer,
            });
          }}
        >
          列印
        </Dropdown.Item>
      </DropdownButton>
    ),

    sheetTable: (
      <div
        id={tableId}
        className="div-table-responsive"
      >
        <table
          style={{
            textAlign: 'center',
            border: '0.5px solid #e5e5e5',
          }}
        >
          <thead>
            <tr>
              <th
                style={headerStyle}
                colSpan={headerElements.length}
              >
                <b>{title}</b>
              </th>
            </tr>

            <tr>{headerElements}</tr>
          </thead>

          <tbody>{bodyElements}</tbody>
        </table>
      </div>
    ),
  };
};
